import { ValuableModel } from '../../models/ValuableModel'

export class SchemaDateModel extends ValuableModel {}

declare global {
  export interface RehajeViewModels {
    'Schema.Date': SchemaDateModel
  }
}
